<template>
  <div class="ff-item" :class="[type, status === 1 ? 'grey': '']">
    <div class="ff-item-inner" :class="[type + '-frame']">
      <img class="ff-img" :src="imgSrc">
      <i class="ff-claimed" v-if="status === 1"></i>
      <span class="item-nums" v-show="nums > 1">X{{nums}}</span>
      <slot></slot>
    </div>
    <div class="ff-name">
       <p v-if="name" v-marquee class="ff-item-name"><span>{{name}}</span></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: String,
    name: String,
    nums: Number || String,
    type: String,
    light: String,
    status: Number
  }
}
</script>

<style lang="scss" scoped>
.ff-item {
  position: relative;
  @include px2res(width, 126);
  .ff-item-inner {
    @include px2res(width, 126);
    @include px2res(height, 126);
    max-width: 100%;
    max-height: 100%;
    position: relative;
    .ff-img {
      max-width: 75%;
      max-height: 75%;
      width: auto;
      height: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .item-nums {
      position: absolute;
      color: #FFDD9C;
      @include px2res(bottom, 6);
      @include px2res(right, -1);
      @include px2res(height, 24);
      @include px2res(line-height, 24);
      @include px2res(font-size, 24);
      @include px2res(padding, 0, 15);
      font-style: italic;
      font-weight: 500;
      z-index: 2;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 40%,
        rgba(0, 0, 0, 0.5) 60%,
        rgba(0, 0, 0, 0) 100%
      );
    }
  }
  .ff-name {
    width: 100%;
    overflow: hidden;
  }
  .ff-item-name {
    @include px2res(font-size, 28);
    @include px2res(margin, 10, auto);
    text-align: center;
    white-space: nowrap;
    color: #FFDBA7;
  }
  .ff-item.light{
    box-shadow: 0 0 2px 10px #ffdc51;
  }
  .drawn-frame .ff-img {
    filter: grayscale(1);
  }
}
.ff-claimed {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  @include px2res(width, 88);
  @include px2res(height, 88);
  background-size: 98% auto;
}
.grey .ff-item-inner {
  .ff-img, .item-nums {
    filter: grayscale(0) brightness(.6);
  }
}
.ff-item.light {
  box-shadow: 0 0 8px 2px rgba(255, 220, 81, .8);
}
.ff-item.grey {
  animation: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Item.vue